import Constant from '@/common/constant/Constant';
import localStorageUtil from '@/common/utils/localStorageUtil';
import Utils from '@/common/utils/utils';
import { createChatPostAPI, deleteChatPortByIdAPI } from '@/service/chatPostService';
import { getPublicAPI, publicGetKnowledgeListAPI, updatePublicAPI } from '@/service/publicService';
import { API, I18n } from 'aws-amplify';
import { getDefaultDataForChatBot } from '../../publicKnowledge/handler/PublicKnowledgeListHandler';
import { v4 as uuidv4 } from 'uuid';
import { getListCategoryAndChatbotSettingWithoutAuthen } from '@/service/projectService';
import { cloneDeep } from 'lodash';
import { createKibanaPublicKnowledgeRobotChat } from '@/component/system/logKibanaHandler/LogKibanaHandler';
import { getMessageFromResolved } from '@/service/messageResolverService';

export const buildListCategoriesMessage = (listCategory, noInFrame = 0) => {
    let content = [];
    let idMessage = getCurrentTimeForMessage();
    listCategory?.forEach(category => {
        let nameOfCategory = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, category.name);
        content.push({ name: nameOfCategory, id: category.id });
    });

    return {
        content: content,
        isFromMe: false,
        messageType: Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.LIST_FORM,
        idMessage: idMessage,
        noInFrame: noInFrame
    };
};

export const buildListTagFieldMessage = (
    listField,
    listFieldIdSelected = [],
    noInFrame = 0,
    isDisplayBackBtn = false,
    usingAI = false,
    listTagFieldSelected = [],
    listTagItemSelected = []
) => {
    let content = [];
    let idMessage = getCurrentTimeForMessage();
    listField?.forEach(tagField => {
        let nameOfTagField = tagField.label;
        content.push({ name: nameOfTagField, id: tagField.id });
    });

    return {
        content: content,
        isFromMe: false,
        messageType: Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.LIST_TAG_FIELD,
        idMessage: idMessage,
        noInFrame: noInFrame,
        isDisplayBackBtn: isDisplayBackBtn,
        usingAI,
        listTagFieldSelected,
        listTagItemSelected
    };
};

export const buildListItemMessage = (
    idOfTagField,
    listItem,
    noInFrame = 0,
    nameOption = '',
    isDisplayBackBtn = false,
    usingAI = false,
    listTagFieldSelected = [], 
    listTagItemSelected = []
) => {
    let content = [];
    let idMessage = getCurrentTimeForMessage();
    listItem?.forEach(item => {
        let nameOfItem = item.label;
        content.push({
            name: nameOfItem,
            id: item.id,
            idOfTagField: idOfTagField,
            firstImage: item.firstImage
        });
    });

    return {
        content: content,
        isFromMe: false,
        messageType: Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.LIST_TAG_ITEM,
        idMessage: idMessage,
        noInFrame: noInFrame,
        nameOption,
        isDisplayBackBtn: isDisplayBackBtn,
        usingAI,
        listTagFieldSelected,
        listTagItemSelected
    };
};

export const buildListTicketMessage = (
    filter,
    noInFrame = 0,
    listSelectedItemOfSessionClone = [],
    usingAI = false
) => {
    let content = [];
    let idMessage = getCurrentTimeForMessage();
    let chatPostId = `post_${uuidv4()}`;
    let message = {
        content: content,
        isFromMe: false,
        messageType: Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.LIST_TICKET,
        idMessage: idMessage,
        filter: filter,
        noInFrame: noInFrame,
        searchData: JSON.stringify(listSelectedItemOfSessionClone),
        chatPostId: chatPostId,
        usingAI
    };
    return message;
};

export const buildMessageSuggestUsingAI = (
    noInFrame = 0,
    resolvedMessages
) => {
    let content = getMessageFromResolved(resolvedMessages, 'bot_suggest_using_ai_message') || I18n.get('MESSAGE_SUGGEST_USING_AI');
    let idMessage = getCurrentTimeForMessage();
    let chatPostId = `post_${uuidv4()}`;
    let message = {
        content: content,
        isFromMe: false,
        messageType: Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.SUGGEST_USING_AI,
        idMessage: idMessage,
        noInFrame: noInFrame,
        chatPostId: chatPostId,
    };
    return message;
};

export const buildConfirmIssuesResolvedMessage = (
    categoryIdSelected,
    formQASystem,
    noInFrame = 0,
    usingAI = false,
    resolvedMessages = null
) => {
    let textMessage = {
        msgKey: !Utils.isEmptyObject(resolvedMessages)
            ? getMessageFromResolved(resolvedMessages, 'bot_confirm_resolved') || I18n.get('CBOTLB001')
            : I18n.get('CBOTLB001'),
        categoryIdSelected: categoryIdSelected,
        formQASystem: formQASystem,
        noInFrame: noInFrame
    };
    let content = [textMessage];
    let idMessage = getCurrentTimeForMessage();
    return {
        content: content,
        isFromMe: false,
        messageType: Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.CONFIRM_ISSUES_RESOLVED,
        idMessage: idMessage,
        noInFrame: noInFrame,
        usingAI
    };
};

export const buildTheEndMessage = (noInFrame = 0, formQASystem = {}, resolvedMessages) => {
    let textMessage = getMessageFromResolved(resolvedMessages, 'bot_end_message') || I18n.get('CBOTMSG006');
    let content = [textMessage];
    let idMessage = getCurrentTimeForMessage();
    return {
        content: content,
        isFromMe: false,
        messageType: Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.THE_END,
        idMessage: idMessage,
        noInFrame: noInFrame,
        formQASystem: formQASystem
    };
};

export const buildBackToBeginMessage = (
    msgKey = 'CBOTMSG013',
    noInFrame = 0,
    formQASystem = {},
    resolvedMessages = null
) => {
    // Store the message key instead of resolved text
    // This allows the component to resolve at render time and update when preview settings change
    let configMsgKey = 'bot_inquiry_cancelled_message'; // default: msgKey = 'CBOTMSG013'
    if (msgKey === 'USER11MSG001') {
        configMsgKey = 'bot_thank_you_message'
    }

    let textMessage = getMessageFromResolved(resolvedMessages, configMsgKey);
    let content = [textMessage];
    let idMessage = getCurrentTimeForMessage();
    return {
        content: content,
        isFromMe: false,
        messageType: Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.BACK_TO_BEGIN,
        idMessage: idMessage,
        noInFrame: noInFrame,
        formQASystem: formQASystem
    };
};

export const BuildFieldUploadMessage = (
    fileKey,
    fileName,
    isFromMe,
    noInFrame = 0,
    postType,
    fileSize
) => {
    let idMessage = getCurrentTimeForMessage();
    return {
        content: fileName,
        isFromMe: isFromMe,
        messageType: Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.FILE_UPLOADED,
        idMessage: idMessage,
        noInFrame: noInFrame,
        fileUrl: fileKey,
        type: 1,
        postType: postType,
        fileSize: fileSize
    };
};

export const buildDataFormQAAfterSubmit = (data, noInFrame = 0, anonymousType) => {
    let textMessage = data;
    let content = [textMessage];
    let idMessage = getCurrentTimeForMessage();
    return {
        content: content,
        isFromMe: false,
        messageType: Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.CONTENT_QA_CHATBOT,
        idMessage: idMessage,
        noInFrame: noInFrame,
        anonymousType: anonymousType
    };
};

export const buildMessageConnecting = (noInFrame = 0, resolvedMessages) => {
    let textMessage = getMessageFromResolved(resolvedMessages, 'bot_connecting_message') || I18n.get('CBOTMSG016');
    let content = [textMessage];
    let idMessage = getCurrentTimeForMessage();
    return {
        content: content,
        isFromMe: false,
        messageType: Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.CONNECTING,
        idMessage: idMessage,
        noInFrame: noInFrame
    };
};

export const buildFreeMessage = (freeMessage, noInFrame = 0) => {
    let textMessage = freeMessage;
    let content = [textMessage];
    let idMessage = getCurrentTimeForMessage();
    return {
        content: content,
        isFromMe: false,
        messageType: Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.FREE_MESSAGE,
        idMessage: idMessage,
        noInFrame: noInFrame
    };
};

export const buildLiveChatMessageFromMe = message => {
    const id = uuidv4();
    let idMessage = getCurrentTimeForMessage();
    return {
        id: id,
        content: message,
        isFromMe: true,
        messageType: Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.LIVE_CHAT_FORM_ME,
        idMessage: idMessage,
        noInFrame: 0
    };
};

export const buildQAFormMessage = (data, resolvedMessages, msgKey = 'CBOTLB009', noInFrame = 0) => {
    let msgConfigKey = ['CBOTMSG011', 'CBOTLB009'].includes(msgKey)
        ? getMessageFromResolved(resolvedMessages, 'bot_form_qa_prompt')
        : I18n.get(msgKey)

    let textMessage = { msgKey: msgConfigKey, data: data };
    let content = [textMessage];
    let idMessage = getCurrentTimeForMessage();
    return {
        content: content,
        isFromMe: false,
        messageType: Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.FORM_QA_IN_CHATBOT,
        idMessage: idMessage,
        noInFrame: noInFrame
    };
};

export const buildQAFormLiveChat = (data, resolvedMessages, noInFrame = 0) => {
    let textMessage = getMessageFromResolved(resolvedMessages, 'bot_qa_form_live_chat_prompt');
    let content = [textMessage];
    let idMessage = getCurrentTimeForMessage();
    return {
        content: content,
        isFromMe: false,
        messageType: Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.QA_FORM_OPTION_LIVE_CHAT,
        idMessage: idMessage,
        noInFrame: noInFrame,
        isDefault: data?.isDefault,
        formQASystem: data?.formQASystem,
        categoryIdSelected: data?.categoryIdSelected,
        idQA: data?.idQA
    };
};

export const checkMessageOutOfSession = (messagesList, idOfMessage) => {
    if (!Utils.isEmptyArray(messagesList))
        return messagesList[messagesList.length - 1].idMessage !== idOfMessage;
    return true;
};

export const getListTicketOfListTag = listTagFieldTicketData => {
    let listKnowledgeId = [];

    listTagFieldTicketData?.forEach(tagField => {
        let ticketItemData = tagField.ticketItemData;
        if (!Utils.isEmptyObject(ticketItemData)) {
            let listIdTicketKnowledge = Object.keys(ticketItemData);
            listIdTicketKnowledge?.forEach(id => {
                if (!listKnowledgeId.includes(id)) listKnowledgeId.push(id);
            });
        }
    });
    return listKnowledgeId;
};

export const getListTicketAfterSelectedOption = (currentListTicket, listTicketOfSelected) => {
    if (Utils.isEmptyArray(currentListTicket)) return listTicketOfSelected;
    let listTicketId = [];

    listTicketOfSelected?.forEach(ticketId => {
        if (currentListTicket.includes(ticketId)) {
            listTicketId.push(ticketId);
        }
    });

    return listTicketId;
};

export const getListTicketOfSelectedTagField = tagFieldTicketData => {
    let ticketItemData = tagFieldTicketData.ticketItemData;
    if (Utils.isEmptyObject(ticketItemData)) return [];

    return Object.keys(ticketItemData);
};

export const getListTicketOfSelectedItem = (tagFieldOfItem, itemId) => {
    let ticketItemData = tagFieldOfItem.ticketItemData;
    if (Utils.isEmptyObject(ticketItemData)) return [];

    let listTicketId = [];
    for (const key in ticketItemData) {
        if (ticketItemData[key]?.includes(itemId)) {
            listTicketId.push(key);
        }
    }

    return listTicketId;
};

export const buildGetAllListKnowledgeOfListTagField = listTagField => {
    let tagFieldQuery = [];

    listTagField?.forEach(tagField => {
        let id = tagField.id;
        let listItem = tagField.child;
        let queries = [];

        listItem?.forEach(item => {
            let query = buildQueryForTagFieldWithSelectedItem(id, item.id);
            queries.push(...query);
        });

        tagFieldQuery.push(...queries);
    });

    return {
        bool: {
            should: tagFieldQuery
        }
    };
};

export const buildQueryForTagFieldWithSelectedItem = (fieldId, itemId) => {
    return [
        {
            simple_query_string: {
                fields: ["fields"],
                query: `${fieldId}:${itemId}`,
                default_operator: "and"
            }
        },
        {
            has_parent: {
                parent_type: "parent",
                query: {
                    simple_query_string: {
                        fields: ["fields"],
                        query: `${fieldId}:${itemId}`,
                        default_operator: "and"
                    }
                }
            }
        }
    ];
};

export const buildQueryForTagField = tagFieldDetail => {
    let tagFieldQuery = [];
    let id = tagFieldDetail.id;
    let listItem = tagFieldDetail.child;
    let queries = [];

    listItem?.forEach(item => {
        let query = buildQueryForTagFieldWithSelectedItem(id, item.id);
        queries.push(...query);
    });

    tagFieldQuery.push(...queries);

    return {
        bool: {
            should: tagFieldQuery
        }
    };
};

export const filterFieldHasNoTicketOption = (
    listFieldDetail,
    listKnowledgeTicket,
    listTagFieldSelected,
    listTagItemSelected
) => {
    // filter tag field selected or there are no tickets
    let listFieldValid = [];
    listFieldValid = listFieldDetail?.filter(field => {
        const listTicketIdOfField = getListTicketOfSelectedTagField(field);

        const listTicketAfterSelectedField = getListTicketAfterSelectedOption(
            listKnowledgeTicket,
            listTicketIdOfField
        );
        if (listTicketAfterSelectedField.length === 0)
            return false;

        let remainTagItemCanDisplay = countRemainTagItemCanDisplayOfField(listTicketAfterSelectedField, field.ticketItemData, listTagItemSelected);
        if (!remainTagItemCanDisplay) return false;

        return true;
    });

    return listFieldValid;
};

const countRemainTagItemCanDisplayOfField = (listTicketAfterSelectedField, fieldTicketItemData, listTagItemSelected = []) => {
    if (Utils.isEmptyArray(listTicketAfterSelectedField) || Utils.isEmptyObject(fieldTicketItemData)) return 0;
    
    let count = 0;
    for (const ticketId of listTicketAfterSelectedField) {
        let ticketTagItemData = fieldTicketItemData?.[ticketId];
        if (!ticketTagItemData) continue;
        for (const ticketTagItemChild of ticketTagItemData) {
            if (!listTagItemSelected.includes(ticketTagItemChild)) {
                count +=1;
            }
        }
        if (count > 0) break;
    }
    
    return count;   
}

export const postMessage = async (
    message,
    supportThreadId,
    corporationId,
    isCreateSessionTimeOutQueue = false,
    isPreviewMode = false,
    idMsg = null,
    selectedOption = {},
    affiliationProject = {},
    projectInuseDetail = {},
    currentCorporationDetail = {},
    categoryIdSelected
) => {
    if (isPreviewMode) return;
    let params = {
        createThreadData: {
            corporationId: corporationId,
            postType: 'support-msg',
            chatThreadId: supportThreadId,
            content: JSON.stringify(message),
            seq: message.idMessage,
            clientUUId: `anonymous_${supportThreadId?.substr(14, 44)}`
        },
        isCreateSessionTimeOutQueue: isCreateSessionTimeOutQueue,
        messageType: message.messageType
    };

    if (idMsg) {
        params.createThreadData.id = idMsg;
    }

    if (!message.isFromMe) {
        params.creatorId = 'system';
    }
    
    if(
        !Utils.isEmptyObject(selectedOption) &&
        !Utils.isEmptyObject(affiliationProject) &&
        !Utils.isEmptyObject(projectInuseDetail) &&
        !Utils.isEmptyObject(currentCorporationDetail)
    ) {
        let logKibana = createKibanaPublicKnowledgeRobotChat(
            selectedOption,
            projectInuseDetail.affiliationOrganization,
            affiliationProject,
            currentCorporationDetail,
            projectInuseDetail,
            message,
            categoryIdSelected
        )

        if(!Utils.isEmptyObject(logKibana)) params.logKibanaData = JSON.stringify(logKibana);
    }

    const chatPost = await createChatPostAPI(API, params);

    return chatPost;
};

export const postMessageLiveChat = async (
    BaseAPI,
    message,
    supportThreadId,
    corporationId,
    ticketId,
    setSentMessageList
) => {
    let params = {
        createThreadData: {
            corporationId: corporationId,
            postType: 'support-msg',
            chatThreadId: supportThreadId,
            content: message.content,
            seq: message.idMessage,
            clientUUId: `anonymous_${supportThreadId?.substr(14, 44)}`,
            id: `post_${message.id}`
        }
    };

    params.createThreadData.ticketId = ticketId;

    params.createThreadData.postType = 'msg';

    params.createThreadData.creatorId = params.createThreadData.clientUUId;
    const chatPost = await createChatPostAPI(BaseAPI ? BaseAPI : API, params);

    if (!chatPost || !chatPost.id) return;
    const idOfChatBot = chatPost.id;
    setSentMessageList(prev => [...prev, { [message.id]: `post_${message.id}` }]);
    return idOfChatBot;
};

export const deleteMsgQA = async (
    supportThreadId,
    corporationId,
    isCreateSessionTimeOutQueue = false,
    isPreviewMode = false,
    idMsg = null
) => {
    if (isPreviewMode) return;
    let params = {
        createThreadData: {
            corporationId: corporationId,
            postType: 'support-msg',
            chatThreadId: supportThreadId
        },
        isCreateSessionTimeOutQueue: isCreateSessionTimeOutQueue,
        type: Constant.ANONYMOUS_CHATBOT_ACTION.DELETE_MSG
    };

    if (idMsg) {
        params.createThreadData.id = idMsg;
    }

    const chatPost = await deleteChatPortByIdAPI(API, params);

    return chatPost;
};

export const createMessageList = async (
    messagesList,
    supportThreadId,
    corporationId,
    isPreviewMode = false,
    selectedOption,
    affiliationProject,
    projectInuseDetail,
    currentCorporationDetail,
    categoryIdSelected
) => {
    if (isPreviewMode) return;
    let executeListCreateChatPost = [];

    messagesList?.forEach(message => {
        if (message.messageType !== Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.LIST_TICKET) {
            executeListCreateChatPost.push(
                postMessage(
                    message,
                    supportThreadId,
                    corporationId,
                    false,
                    false,
                    null,
                    selectedOption,
                    affiliationProject,
                    projectInuseDetail,
                    currentCorporationDetail,
                    categoryIdSelected
                )
            );
        }
    });

    await Promise.all(executeListCreateChatPost);
};

export const getDrillDownDataForChatBot = async (
    projectId,
    subDomain,
    structure,
    corporationId,
    viewId
) => {
    let response = await publicGetKnowledgeListAPI(API, {
        getApiType: Constant.GET_API_PUBLIC_TYPE.GET_PUBLIC_KNOWLEDGE_DRILLDOWN_DATA_FOR_CHATBOT,
        subDomain,
        projectId,
        structure,
        corporationId,
        viewId
    });
    const payload = Utils.convertJSONDataToObject(response.payload);
    let drillDownData = getDefaultDataForChatBot(payload, structure);
    drillDownData.totalTicketInList = payload.totalTicketInList

    return drillDownData;
};

export const buildLoadTagFiledMessage = (idOfCategory, formQASystem, noInFrame = 0, usingAI = false, listTagFieldSelected = [], listTagItemSelected = []) => {
    let idMessage = getCurrentTimeForMessage();
    return {
        content: [],
        isFromMe: false,
        messageType: Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.LOADING_GET_LIST_TAG_FIELD,
        idMessage: idMessage,
        noInFrame: noInFrame,
        idOfCategory: idOfCategory,
        formQASystem: formQASystem,
        usingAI,
        listTagFieldSelected,
        listTagItemSelected
    };
};

const buildParamsGetDrilldown = viewStructure => {
    let params = Constant.DEFAULT_VIEW_STRUCTURE;
    if (viewStructure && !Utils.isEmptyObject(viewStructure)) {
        return viewStructure;
    }
    return params;
};

export const prepareDataForChatBotV2 = async (
    projectAlias,
    subdomain,
    isPreview = false,
    supportThreadType = ''
) => {
    let requestParams = {
        projectAlias: projectAlias,
        type: Constant.FORM_TYPE.FORM_REQ_QA,
        getApiType: Constant.GET_API_PUBLIC_TYPE.PREPARE_DATA_CHAT_BOT,
        subDomain: subdomain,
        clientSupportThread: Utils.isEmptyObject(
            localStorageUtil.getAnonymousSupportId(supportThreadType)
        )
            ? {}
            : localStorageUtil.getAnonymousSupportId(supportThreadType),
        structure: buildParamsGetDrilldown(Constant.DEFAULT_VIEW_STRUCTURE),
        isPreview: isPreview
    };
    const response = await getPublicAPI(API, requestParams);
    let payload = Utils.convertJSONDataToObject(response.payload);
    return payload;
};

export const getFormSystemQA = async (subdomain, isPreview = false) => {
    let requestParams = {
        getApiType: Constant.GET_API_PUBLIC_TYPE.GET_FORM_QA_SYSTEM,
        subDomain: subdomain
    };
    const response = await getPublicAPI(API, requestParams);
    let payload = Utils.convertJSONDataToObject(response.payload);
    return payload;
};

export const sortListPreviousMessage = (array, resolvedMessages) => {
    array.forEach(msg => {
        if (
            msg &&
            [Constant.POST_TYPE.MSG, Constant.POST_TYPE.IMAGE, Constant.POST_TYPE.FILE, Constant.POST_TYPE.MSG_FILES].includes(
                msg?.postType
            ) &&
            msg?.deliverInfo?.status &&
            msg?.deliverInfo?.deliverAt &&
            msg.affiliationProject 
        ) {
            msg.seq = new Date(msg?.deliverInfo?.deliverAt).getTime(); 
        }
    });

    let listMessage = array.sort((a, b) => {
        const numA = Number(a.seq);
        const numB = Number(b.seq);

        if (numA === numB) {
            let contentOfA = Utils.convertJSONDataToObject(a.content);
            let contentOfB = Utils.convertJSONDataToObject(b.content);
            return contentOfA.noInFrame - contentOfB.noInFrame;
        } else {
            return Number(a.seq) - Number(b.seq);
        }
    });
    listMessage = listMessage?.filter(message => {
        return message.postType !== Constant.POST_TYPE.SYSTEM_AUTO_END_LIVE_CHAT;
    });
    const listContentMessage = Array.from(listMessage, item => {
        let newMessage;
        if (item.creatorId?.includes('user_')) {
            newMessage = renderMessageOfAgent(item, resolvedMessages);
            if (item.postType === 'file' || item.postType === 'image') {
                newMessage = {
                    id: item.id,
                    content: Utils.convertJSONDataToObject(item.content),
                    isFromMe: false,
                    idMessage: item.seq,
                    fileUrl: item.fileUrl,
                    fileSize: item.fileSize,
                    thumbnailInfo: item.thumbnailInfo,
                    postType: item.postType,
                    creatorId: item.creatorId,
                    status: item.status
                };
                newMessage.messageType = Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.FILE_UPLOADED;
            }
            if (item.postType === Constant.POST_TYPE.MSG_FILES) {
                let attachFiles = Utils.convertJSONDataToObject(item.attachFiles);
                newMessage = {
                    id: item.id,
                    content: item.content,
                    isFromMe: false,
                    idMessage: item.seq,
                    messageType: Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.MSG_FILES_WITH_IMAGES,
                    creatorId: item.creatorId,
                    status: item.status,
                    mention: item.mention,
                    attachFiles: Utils.isEmptyArray(attachFiles) ? [] : attachFiles
                };
            }
        } else {
            newMessage = Utils.convertJSONDataToObject(item.content);
            if (item.postType === 'msg') {
                newMessage = {
                    id: item.id,
                    content: Utils.convertJSONDataToObject(item.content),
                    isFromMe: true,
                    idMessage: Number(item.seq),
                    mention: item.mention
                };
                newMessage.messageType = Utils.isEmptyArray(item.mention)
                    ? Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.LIVE_CHAT
                    : Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.LIVE_CHAT_MENTION;
            }

            if (item.postType === 'file' || item.postType === 'image') {
                newMessage = {
                    id: item.id,
                    content: Utils.convertJSONDataToObject(item.content),
                    isFromMe: true,
                    idMessage: Number(item.seq),
                    fileUrl: item.fileUrl,
                    fileSize: item.fileSize,
                    thumbnailInfo: item.thumbnailInfo,
                    postType: item.postType
                };
                newMessage.messageType = Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.FILE_UPLOADED;
            }

            if (item.postType === Constant.POST_TYPE.CHAT_BOT_CONNECTED_WITH_AGENT) {
                if (item.content === getMessageFromResolved(resolvedMessages, 'bot_connected_message')) {
                    newMessage = {
                        content: item.content,
                        isFromMe: false,
                        idMessage: item.seq,
                        messageType: Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.CONNECTED,
                        isShowButton: false
                    };
                }
            }

            if (item.postType === Constant.POST_TYPE.CHAT_BOT_NOT_FOUND_AGENT) {
                if (item.content === getMessageFromResolved(resolvedMessages, 'bot_not_found_agent_message')) {
                    newMessage = {
                        content: item.content,
                        isFromMe: false,
                        idMessage: item.seq,
                        messageType: Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.NOT_FOUND_AGENT,
                        isShowButton: true
                    };
                }
            }
            if (item.postType === Constant.POST_TYPE.END_LIVE_CHAT_MESSAGE) {
                if (item.content === getMessageFromResolved(resolvedMessages, 'bot_end_live_chat_message')) {
                    newMessage = {
                        id: item.id,
                        content: item.content,
                        isFromMe: false,
                        idMessage: item.seq,
                        postType: item.postType,
                        messageType: Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.END_LIVE_CHAT
                    };
                }
            }
        }

        return newMessage;
    });
    return listContentMessage;
};

export const checkDataChangeInChatbot = async (
    projectAlias,
    subDomain,
    settingChatBot,
    categoryId,
    listCategorieQA,
    projectId,
    isIframeChatBot
) => {
    let response = {
        status: false
    };

    let paramValidate = {
        getApiType: Constant.GET_API_PUBLIC_TYPE.GET_LIST_CATEGORY_AND_SETTING_CHATBOT,
        projectAlias: projectAlias,
        subDomain: subDomain,
        isIframeChatBot: isIframeChatBot
    };

    let projectInfo = await getListCategoryAndChatbotSettingWithoutAuthen(API, paramValidate);
    if (!projectInfo.success) {
        return response;
    }

    let chatbotSettingNew = projectInfo?.chatbotSetting;
    let listCategoriesProjectNew = projectInfo?.listCategoriesProject;
    let publicKnowledgeSiteSetting = projectInfo?.publicKnowledgeSiteSetting;

    if (settingChatBot?.actionWhenNotResolve !== chatbotSettingNew?.actionWhenNotResolve) {
        response.chatbotSettingNew = chatbotSettingNew;
        return response;
    }

    if (
        !chatbotSettingNew?.isActivateChatbot ||
        (!isIframeChatBot && !publicKnowledgeSiteSetting?.isShowChatbot)
    ) {
        return response;
    }

    if (categoryId) {
        let categoryDetailCurrent = listCategorieQA.filter(category => category.id === categoryId);
        let categoryDetailNew = listCategoriesProjectNew?.filter(
            category => category?.id === categoryId
        );

        let formCurrent = categoryDetailCurrent[0]?.formfieldAnonymous;
        let formNew = categoryDetailNew[0]?.formfieldAnonymous;

        let formIdCurrent = categoryDetailCurrent[0]?.formfieldAnonymous?.id;
        let formIdNew = categoryDetailNew[0]?.formfieldAnonymous?.id;

        if (
            formIdCurrent !== formIdNew ||
            formCurrent?.usingProjects?.includes(projectId) !==
                formNew?.usingProjects?.includes(projectId)
        ) {
            response.chatbotSettingNew = chatbotSettingNew;
            return response;
        }
    }

    response.status = true;
    return response;
};

export const renderMessageOfAgent = (message, resolvedMessages = null) => {
    let content = Utils.convertJSONDataToObject(message.content);
    let newMessage = {};
    switch (content?.messageType) {
        case Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.NOT_FOUND_AGENT:
            newMessage = content;
            break;
        case Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.BACK_TO_BEGIN_AFTER_REJECT:
            newMessage = content;
            break;
        default:
            switch (message.postType) {
                case Constant.POST_TYPE.CHAT_BOT_NOT_FOUND_AGENT:
                    if (message.content === I18n.get('CBOTMSG012')) {
                        newMessage = {
                            content: !Utils.isEmptyObject(resolvedMessages)
                                ? getMessageFromResolved(resolvedMessages, 'bot_not_found_agent_message')
                                : message.content,
                            isFromMe: false,
                            idMessage: message.seq,
                            messageType: Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.NOT_FOUND_AGENT,
                            isShowButton: true
                        };
                    }
                    break;
                case Constant.POST_TYPE.CHAT_BOT_CONNECTED_WITH_AGENT:
                    if (message.content === I18n.get('CBOTMSG019')) {
                        newMessage = {
                            content: !Utils.isEmptyObject(resolvedMessages)
                                ? getMessageFromResolved(resolvedMessages, 'bot_connected_message')
                                : message.content,
                            isFromMe: false,
                            idMessage: message.seq,
                            messageType: Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.CONNECTED,
                            isShowButton: false
                        };
                    }
                    break;
                case Constant.POST_TYPE.END_LIVE_CHAT_MESSAGE:
                    if (message.content === I18n.get('CBOTMSG018')) {
                        newMessage = {
                            id: message.id,
                            content: !Utils.isEmptyObject(resolvedMessages)
                                ? getMessageFromResolved(resolvedMessages, 'bot_end_live_chat_message')
                                : message.content,
                            isFromMe: false,
                            idMessage: message.seq,
                            postType: message.postType,
                            messageType: Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.END_LIVE_CHAT
                        };
                    }

                    break;
                case Constant.POST_TYPE.IMAGE:
                case Constant.POST_TYPE.FILE:
                    newMessage = {
                        id: message.id,
                        content: Utils.convertJSONDataToObject(message.content),
                        isFromMe: false,
                        idMessage: convertIdMessage(message),
                        fileUrl: message.fileUrl,
                        fileSize: message.fileSize,
                        thumbnailInfo: message.thumbnailInfo,
                        postType: message.postType,
                        creatorId: message.creatorId,
                        status: message.status
                    };
                    newMessage.messageType = Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.FILE_UPLOADED;
                    break;
                case Constant.POST_TYPE.MSG:
                    newMessage = {
                        id: message.id,
                        content: message.content,
                        isFromMe: false,
                        idMessage: convertIdMessage(message),
                        messageType: Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.AGENT_MESSAGE,
                        creatorId: message.creatorId,
                        status: message.status,
                        mention: message.mention
                    };
                    newMessage.messageType = Utils.isEmptyArray(message.mention)
                        ? Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.LIVE_CHAT
                        : Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.LIVE_CHAT_MENTION;
                    break;
                case Constant.POST_TYPE.MSG_FILES:
                    newMessage = {
                        id: message.id,
                        content: message.content,
                        isFromMe: false,
                        idMessage: convertIdMessage(message),
                        messageType: Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.MSG_FILES_WITH_IMAGES,
                        creatorId: message.creatorId,
                        status: message.status,
                        mention: message.mention,
                        attachFiles: message.attachFiles || []
                    };
                    break;
                default:
                    break;
            }
            break;
    }
    return newMessage;
};

const convertIdMessage = (message) => {
    let idMessage = message.seq;
    if (message?.deliverInfo?.deliverAt) {
       idMessage = new Date(message?.deliverInfo?.deliverAt).getTime(); 
    }

    return idMessage;
}

export const onSubscriptionUpdateMessage = (messages, setMessages, messageUpdated, resolvedMessages) => {
    const indexOfUpdatedMessage = messages?.findIndex(message => {
        return message.id === messageUpdated.id;
    });
    if (indexOfUpdatedMessage !== -1) {
        let messageClone = cloneDeep({ ...messages[indexOfUpdatedMessage] });
        if (messageClone.content !== messageUpdated.content) {
            messageClone.content = messageUpdated.content;
            messageClone.updatedAt = messageUpdated.updatedAt;
        }
        let messageListClone = [...messages];
        messageListClone[indexOfUpdatedMessage] = messageClone;
        setMessages([...messageListClone]);
    // Case undeliver => Deliver
    } else if (
        [Constant.POST_TYPE.MSG, Constant.POST_TYPE.IMAGE, Constant.POST_TYPE.FILE, Constant.POST_TYPE.MSG_FILES].includes(
            messageUpdated?.postType
        ) &&
        messageUpdated?.deliverInfo?.status &&
        messageUpdated.affiliationProject
    ) {
        let newMessage = renderMessageOfAgent(messageUpdated, resolvedMessages);
        setMessages(pev => [...pev, newMessage]);
    }
};

export const onSubscriptionDeleteMessage = (messages, setMessages, messageDeleted) => {
    const indexOfUpdatedMessage = messages?.findIndex(message => {
        return message.id === messageDeleted.id;
    });
    if (indexOfUpdatedMessage !== -1) {
        let messageClone = cloneDeep({ ...messages[indexOfUpdatedMessage] });
        messageClone.updatedAt = new Date();
        messageClone.isDeleted = true;
        messageClone.status = 4;
        let messageListClone = [...messages];
        messageListClone[indexOfUpdatedMessage] = messageClone;
        setMessages([...messageListClone]);
    }
};

//NOTE: get member list : https://new.redmine.ominext.com/issues/80737
export const updateAgentDataList = async (projectId, corporationId, setListAgentData) => {
    let response = await getPublicAPI(API, {
        getApiType: Constant.GET_API_PUBLIC_TYPE.GET_LIST_AGENT_DATA,
        projectId: projectId,
        corporationId: corporationId
    });

    let data = Utils.convertJSONDataToObject(response.payload);
    if (!Utils.isEmptyArray(data)) {
        setListAgentData([...data]);
    }
};

export const getCurrentTimeForMessage = () => {
    let currentTime = new Date().getTime();
    return currentTime;
    // let currentUTCTime = new Date(
    //     currentTime.getUTCFullYear(),
    //     currentTime.getUTCMonth(),
    //     currentTime.getUTCDate(),
    //     currentTime.getUTCHours(),
    //     currentTime.getUTCMinutes(),
    //     currentTime.getUTCSeconds(),
    //     currentTime.getUTCMilliseconds()
    // );
    // return currentUTCTime.getTime()
};

export const anounymousEndLiveChat = async ticketId => {
    if (!ticketId) return;

    let param = {
        updateApiType: Constant.UPDATE_API_PUBLIC_TYPE.ANONYMOUS_END_LIVE_CHAT,
        ticketId: ticketId
    };
    let result = await updatePublicAPI(API, param);
    return result;
};


export const getDisplayOptionBySetting = (option, optionDisplayLength) => {
    option = option.trim();
    if (!optionDisplayLength || optionDisplayLength > Constant.SETTING_CHAT_BOT.MAX_OPTION_DISPLAY_LENGTH.MAX) return option;
    if (option.length > parseInt(optionDisplayLength)) {
        return `${option.substring(0, parseInt(optionDisplayLength))}...`;
    }
    return option;
}

export const getOptionDisplayLength = (chatbotSettings, previewSetting) => {
    let optionDisplayLength = 0;

    if (chatbotSettings.optionDisplayLength) {
        optionDisplayLength = chatbotSettings.optionDisplayLength;
    }
    if (previewSetting.optionDisplayLength) {
        optionDisplayLength = previewSetting.optionDisplayLength;
    }

    return optionDisplayLength;
}


export const getListTagFieldOfCategory = async (
    projectId,
    subDomain,
    affiliationOrganization,
    categoryDetail,
    setListTagFieldOfSelectedCategory
) => {
    const viewStructure = categoryDetail.viewStructure;

    const viewId = categoryDetail?.chatBotCategorySetting?.viewId;
    const response = await getDrillDownDataForChatBot(
        projectId,
        subDomain,
        viewStructure,
        affiliationOrganization,
        viewId
    );

    let tagFiledList = [];

    const listTagFiledId = categoryDetail.listTagFiledId;
    let settingTagFiledOfCategory = categoryDetail?.chatBotCategorySetting?.tagFields;
    response?.tagFieldList?.forEach(tagField => {
        if (listTagFiledId.includes(tagField.id)) {
            const settingTagFiled = settingTagFiledOfCategory.find(setting => {
                return setting.id === tagField.id;
            });

            if (!Utils.isEmptyObject(settingTagFiled)) {
                tagField.priority = settingTagFiled?.priority;
                tagField.order = settingTagFiled.order;

                tagFiledList.push(tagField);
            }
        }
    });

    tagFiledList = Utils.sortListTagFieldOfCategory(cloneDeep(tagFiledList));
    setListTagFieldOfSelectedCategory(tagFiledList);
};
